export function callWithoutContext(fn, ...args) {
  window.setTimeout(fn.bind(null, ...args), 0);
}
